import React from "react";
import {StyledContainer,PageTitle,ContentContainer,ButtonContainer, FooterContainer } from "./styles";
import type { ColumnsType, TableProps } from 'antd/es/table';
import { Table,Button, Row } from 'antd';
import { useForm } from "../../utility/useForm";
import Spinner from "../_common/Spinner";
import { NavigateFunction, useNavigate } from "react-router-dom";


export interface FormProps {
  title?: string;
  saveButtonTitle?:string
  cancelButtonTitle?:string
  extraButtonTitle?:string
  onCancel?: any,
  onSubmit?:any,
  onExtraClick?:any,
  isLoading?:boolean,
  isSubmiting:boolean,
  children?: React.ReactNode;
}


const FormContainer = ({title,saveButtonTitle="ثبت",cancelButtonTitle="انصراف",extraButtonTitle,onCancel,onSubmit,onExtraClick,isLoading,isSubmiting,children }: FormProps) => {

  const navigate = useNavigate();


  return (
    <StyledContainer>

    {isLoading === false && (
      <>
          { title && (
              <PageTitle>{title}</PageTitle>
          )}
        
          <ContentContainer>
            <form onSubmit={onSubmit}>
                <fieldset disabled={isSubmiting}>
                  <>{children}</>
          
                  <FooterContainer>
                    <Row>
                      <ButtonContainer>
                        { saveButtonTitle && (
                          <Button type="primary" style={{backgroundColor:"Green",margin:"5px"}}  htmlType="submit" disabled={isSubmiting} >{saveButtonTitle}</Button>
                        )}
                        
                        { cancelButtonTitle && (
                            <Button type="primary" style={{backgroundColor:"red",margin:"5px"}} disabled={isSubmiting} onClick={() => onCancel ? onCancel() : navigate(-1)}>{cancelButtonTitle}</Button>
                        )}
                      </ButtonContainer>
                    </Row>

                    { extraButtonTitle && (
                      <Row>
                        <Button type="primary" style={{backgroundColor:"blue",margin:"5px"}} disabled={isSubmiting} onClick={() => onExtraClick()}>{extraButtonTitle}</Button>
                      </Row>
                    )}

                    <Row>
                      {isSubmiting === true && (
                            <Spinner size="default" message={" "}/>                 
                      )}
                    </Row>
                  </FooterContainer>
                </fieldset>
            </form>
          </ContentContainer>
      </>
    )}

    {isLoading === true && (
            <Spinner/>
    )}

    </StyledContainer>
  )

}

export default FormContainer;